import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { taxCodeEndpoints } from '@/lib/api/endpoints';
import { taxZoneKeys, taxGroupKeys } from '@/lib/queryKeys';

export function useRestoreTaxCodeRate() {
  const qc = useQueryClient();
  return useApiMutation<void, string>({
    mutationFn: (id) => apiPost<void>(operationsClient, taxCodeEndpoints.restoreRate(id)),
    onSuccess: () => {
      toast.success('Tax rate restored to original.');
      void qc.invalidateQueries({ queryKey: taxZoneKeys.all() });
      void qc.invalidateQueries({ queryKey: taxGroupKeys.all() });
    },
  });
}
